import { useState, useCallback } from 'react';
import api from '../api/client';

const useGetURLStatus = () => {
  const [isCargando, setCargando] = useState(false);
  const [erroresGet, setErroresGet] = useState(null);
  const [status, setStatus] = useState(null);

  const fetchData = useCallback(async (path, usarDatos) => {
    setCargando(true);
    setErroresGet(null);
    try {
      const res = await api.get(path);
      setStatus(res.status ?? null);

      if (res.ok) {
        usarDatos(res.data ?? null);
      } else {
        setErroresGet(res.errors ?? ['Error al cargar los datos']);
        usarDatos(null);
      }
    } catch (error) {
      console.error('Error Get', error.message ?? error);
      setErroresGet(['Error al cargar los datos']);
      usarDatos(null);
    }
    setCargando(false);
  }, []);

  const resetErroresGet = useCallback(() => {
    setErroresGet(null);
    setStatus(null);
  }, []);

  return { isCargando, status, erroresGet, fetchData, resetErroresGet };
};

export default useGetURLStatus;
